import React from 'react';
import Timeline from "react-time-line";


/*Get JSX Status TimeLime */
const GetJSXTimeLime = (props) => {
    const { ExperimentInformation, ExperimentStatus } = props;
    let events = [];
    /*Load Data*/
    events.push({ts:ExperimentInformation.LOADDATE, text: 'Experiment Submitted' });
    /*Raw Download*/
    if ( ExperimentStatus.rawDownload.status.toLowerCase() === "pass"){
        events.push({ts:ExperimentStatus.rawDownload.timestamp, text: 'Data at CNAG' })
    }
    /*Reception Pipeline*/
    if ( ExperimentStatus.receptionPipeline.status.toLowerCase() === "pass"){
        events.push({ts:ExperimentStatus.receptionPipeline.timestamp, text: 'Quality Checking' })
    }
    /*Mapping*/
    if ( ExperimentStatus.mapping.status.toLowerCase() === "pass"){
        events.push({ts:ExperimentStatus.mapping.timestamp, text: 'Mapping' })
    }
    /*Variant Calling*/
    if ( ExperimentStatus.variantCalling.status.toLowerCase() === "pass"){
        events.push({ts:ExperimentStatus.variantCalling.timestamp, text: 'Variant Calling' })
    }
    /*CNV*/
    if ( ExperimentStatus.cnv.status.toLowerCase() === "pass"){
        events.push({ts:ExperimentStatus.cnv.timestamp, text: 'Copy Number Variance' })
    }
    /*Runs of Homosygosity*/
    if ( ExperimentStatus.rohs.status.toLowerCase() === "pass"){
        events.push({ts:ExperimentStatus.rohs.timestamp, text: 'Runs of Homosygosity' })
    }
    /*In Platform*/
    if ( ExperimentStatus.in_platform.status.toLowerCase() === "pass"){
        events.push({ts:ExperimentStatus.in_platform.timestamp, text: 'In Platform' })
    }
    return <Timeline items={events} />;
};

/*Analysis Timeline Component*/
const AnalysisTimeLine = (props) => {
    
    const { ExperimentInformation, ExperimentStatus } = props;
    
    const titleStyle = { color: "#4575B4"};

    if (typeof ExperimentStatus.rawDownload !== 'undefined') {
        return(
            <div>
                <h5 style={titleStyle} className="mx-3 my-3"> Analysis Time Line </h5>
                <div className="row px-md-5 my-3">
                    <GetJSXTimeLime   
                        ExperimentInformation={ExperimentInformation}
                        ExperimentStatus={ExperimentStatus}
                    />                   
                </div>
            </div>
        );
    }
    else {
        return (<div> </div>);
    }
}

export default AnalysisTimeLine;